window.ConversionTracking = window.ConversionTracking || {};

function compactConversionTrackingValue(value) {
  if (Array.isArray(value)) {
    const compactedArray = value
      .map((entry) => compactConversionTrackingValue(entry))
      .filter((entry) => entry !== undefined);

    return compactedArray.length > 0 ? compactedArray : undefined;
  }

  if (value && typeof value === "object") {
    const compactedObject = Object.entries(value).reduce((memo, [key, entry]) => {
      const compactedEntry = compactConversionTrackingValue(entry);
      if (compactedEntry !== undefined) memo[key] = compactedEntry;
      return memo;
    }, {});

    return Object.keys(compactedObject).length > 0 ? compactedObject : undefined;
  }

  if (value == null) return undefined;
  if (typeof value === "string" && value.trim() === "") return undefined;

  return value;
}

window.ConversionTracking.googleConversion = function(sendTo, opts = {}) {
  const userData = compactConversionTrackingValue(opts.user_data);
  const debugPayload = { send_to: sendTo };
  if (opts.value != null) debugPayload.value = opts.value;
  if (opts.currency) debugPayload.currency = opts.currency;
  if (opts.transaction_id) debugPayload.transaction_id = opts.transaction_id;
  if (userData) debugPayload.user_data = userData;

  if (typeof window.gtag !== "function") {
    console.warn("[Google Ads] gtag unavailable, conversion skipped", debugPayload);
    return { fired: false, reason: "gtag_unavailable", payload: debugPayload };
  }

  // 🧪 Development / Staging: nur loggen, nicht senden
  if (
    window.location.hostname.includes("localhost") ||
    window.location.hostname.includes("dev") ||
    window.location.hostname.includes("staging")
  ) {
    console.info("[DEV] Google Ads conversion suppressed", debugPayload);
    return { fired: false, reason: "suppressed_non_production", payload: debugPayload };
  }

  const payload = { send_to: sendTo };
  if (opts.value != null) payload.value = opts.value;
  if (opts.currency) payload.currency = opts.currency;
  if (opts.transaction_id) payload.transaction_id = opts.transaction_id;

  console.info("[Google Ads] preparing conversion payload", {
    send_to: sendTo,
    payload,
    has_user_data: !!userData
  });

  if (userData) {
    console.info("[Google Ads] setting enhanced conversion user_data", {
      send_to: sendTo,
      user_data: userData
    });
    gtag("set", "user_data", userData);
  }

  console.info("[Google Ads] firing gtag conversion event", debugPayload);
  gtag("event", "conversion", payload);

  // ✅ Erfolgs-Log (bedeutet: Call wurde ausgelöst, nicht dass Google ihn "gezählt" hat)
  console.info("[Google Ads] conversion event fired", debugPayload);
  return { fired: true, payload };
};
